import { Component, OnInit } from "@angular/core";

@Component({
    selector: "app-extra-scroll",
    templateUrl: "./extra-scroll.component.html",
    styleUrls: ["./extra-scroll.component.scss"]
})
export class ExtraScrollComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
